import React, { useState, useCallback } from 'react';
import { Button, Loading, Checkbox, Radio, Input } from '@nextui-org/react';

const FilterReceipt = ({ 
  handleSearchButton, 
  clicked,
  receiptReference: initialReceiptReference = null,
  driverId: initialDriverId = '',
  exp1: initialExp1 = '',
  exp2: initialExp2 = '',
  Approved: initialApproved = 0,
  Denied: initialDenied = 0,
  New: initialNew = 0,
  DateMatch: initialDateMatch = 0,
  TotalMatch: initialTotalMatch = 0,
  orderNo: initialOrderNo = ''
}) => {
  const [filters, setFilters] = useState({
    receiptReference: initialReceiptReference,
    driverId: initialDriverId,
    exp1: initialExp1,
    exp2: initialExp2,
    Approved: initialApproved,
    Denied: initialDenied,
    New: initialNew,
    DateMatch: initialDateMatch,
    TotalMatch: initialTotalMatch,
    orderNo: initialOrderNo
  });

  const updateFilter = useCallback((key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  }, []);

  const handleStatusChange = useCallback((status) => {
    setFilters(prev => ({
      ...prev,
      Approved: status === 'Approved' ? (prev.Approved === 0 ? 1 : 0) : 0,
      Denied: status === 'Denied' ? (prev.Denied === 0 ? 1 : 0) : 0,
      New: status === 'New' ? (prev.New === 0 ? 1 : 0) : 0
    }));
  }, []);

  const handleMatchChange = useCallback((type) => {
    setFilters(prev => ({
      ...prev,
      [type]: prev[type] === 0 ? 1 : 0
    }));
  }, []);

  const countActiveFilters = useCallback(() => {
    return Object.entries(filters).reduce((count, [key, value]) => {
      if (value !== '' && value !== 0 && value !== null) {
        return count + 1;
      }
      return count;
    }, 0);
  }, [filters]);

  const handleReset = useCallback(() => {
    setFilters({
      receiptReference: null,
      driverId: '',
      exp1: '',
      exp2: '',
      Approved: 0,
      Denied: 0,
      New: 0,
      DateMatch: 0,
      TotalMatch: 0,
      orderNo: ''
    });
    handleSearchButton('', '', 0, 0, 0, '', '', null, 0, 0, 0);
  }, [handleSearchButton]);

  const handleSearch = useCallback(() => {
    const filterCount = countActiveFilters();
    handleSearchButton(
      filters.exp1,
      filters.exp2,
      filters.Approved,
      filters.Denied,
      filters.New,
      filters.driverId,
      filters.orderNo,
      filters.receiptReference,
      filters.DateMatch,
      filters.TotalMatch,
      filterCount
    );
  }, [filters, handleSearchButton, countActiveFilters]);

  return (
    <div className="pa2 mr4">
      <div>
        <label className="f5">Receipt Reference</label>
        <Input
          type="number"
          placeholder="Receipt Reference"
          onChange={(e) => updateFilter('receiptReference', e.target.value)}
          css={{ $$inputBorderRadius: "0", w: '100%', h: 38, mt: 5 }}
          shadow={false}
          bordered={true}
          rounded={false}
          value={filters.receiptReference || ''}
        />
      </div>

      <div className="mt2">
        <label className="f5">Driver ID</label>
        <Input
          type="text"
          placeholder="Enter Driver ID"
          onChange={(e) => updateFilter('driverId', e.target.value)}
          clearable
          css={{ $$inputBorderRadius: "0", w: '100%', h: 38, mt: 5 }}
          shadow={false}
          bordered={true}
          rounded={false}
          value={filters.driverId}
        />
      </div>

      <div className="mt2">
        <label className="f5">Order Number</label>
        <Input
          type="text"
          placeholder="Enter Order Number"
          onChange={(e) => updateFilter('orderNo', e.target.value)}
          clearable
          css={{ $$inputBorderRadius: "0", w: '100%', h: 38, mt: 5 }}
          shadow={false}
          bordered={true}
          rounded={false}
          value={filters.orderNo}
        />
      </div>

      <div className="mt2">
        <label className="f5">From</label>
        <Input
          type="date"
          onChange={(e) => updateFilter('exp1', e.target.value)}
          css={{ $$inputBorderRadius: "0", w: '100%', h: 38, mt: 5 }}
          shadow={false}
          bordered={true}
          rounded={false}
          value={filters.exp1}
        />
        <div className="mh2">
          <label className="f5">To</label>
        </div>
        <Input
          type="date"
          onChange={(e) => updateFilter('exp2', e.target.value)}
          css={{ $$inputBorderRadius: "0", w: 192, h: 38, mt: 5 }}
          shadow={false}
          bordered={true}
          rounded={false}
          value={filters.exp2}
        />
      </div>

      <div className="flex justify-space-between mt3">
        <div className="f5 w-100">New</div>
        <Radio 
          checked={filters.New === 1} 
          onChange={() => handleStatusChange('New')} 
        />
      </div>

      <div className="flex justify-space-between mt3">
        <div className="f5 w-100">Approved</div>
        <Radio 
          checked={filters.Approved === 1} 
          onChange={() => handleStatusChange('Approved')} 
        />
      </div>

      <div className="flex justify-space-between mt3">
        <div className="f5 w-100">Rejected</div>
        <Radio 
          checked={filters.Denied === 1} 
          onChange={() => handleStatusChange('Denied')} 
        />
      </div>

      <div className="flex justify-space-between mt3 mr2">
        <div className="f5 w-100">Dates Match</div>
        <Checkbox 
          checked={filters.DateMatch === 1} 
          onChange={() => handleMatchChange('DateMatch')} 
        />
      </div>

      <div className="flex justify-space-between mt3 mr2">
        <div className="f5 w-100">Totals Match</div>
        <Checkbox 
          checked={filters.TotalMatch === 1} 
          onChange={() => handleMatchChange('TotalMatch')} 
        />
      </div>

      <div className="flex flex-row justify-center items-center justify-between mt3">
        <Button 
          size="sm"
          ghost
          auto
          css={{ br: 0, color: '$gray600', borderColor: '$gray600' }}
          onClick={handleReset}
        >
          Reset
        </Button>

        {clicked ? (
          <Button
            auto
            css={{ br: 0 }}
            loading
          >
            <Loading type="points" size="md" color="white" />
          </Button>
        ) : (
          <Button 
            size="sm"
            auto
            css={{ br: 0 }}
            onClick={handleSearch}
          >
            Search
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterReceipt;